(() => {
  if (window.pdGalleryLoaded) return;
  window.pdGalleryLoaded = true;

  const initialized = new WeakSet();

  const reduced = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (initialized.has(root)) return;

    const track = root.querySelector('.pd-gallery__track');
    const links = track
      ? [...track.querySelectorAll('.pd-gallery__image')]
      : [];

    if (!track || !links.length) return;

    initialized.add(root);

    /* GÖRSEL BÜYÜTME */
    let box;
    let large;
    let selected = 0;
    let opener;

    function loadImage() {
      large.src = links[selected].href;
      large.alt = links[selected].querySelector('img')?.alt || '';
    }

    function lightMove(direction) {
      selected =
        (selected + direction + links.length) % links.length;

      loadImage();
    }

    function createLightbox() {
      box = document.createElement('dialog');
      box.className = 'pd-gallery__lightbox';
      box.setAttribute('aria-label', 'Büyük görsel galerisi');

      box.innerHTML = `
        <button
          type="button"
          class="pd-gallery__close"
          aria-label="Kapat"
        >×</button>

        <button
          type="button"
          class="pd-gallery__previous"
          aria-label="Önceki görsel"
        >←</button>

        <img alt="">

        <button
          type="button"
          class="pd-gallery__next"
          aria-label="Sonraki görsel"
        >→</button>
      `;

      document.body.append(box);

      large = box.querySelector('img');

      const close = box.querySelector('.pd-gallery__close');
      const previous = box.querySelector('.pd-gallery__previous');
      const next = box.querySelector('.pd-gallery__next');

      close.addEventListener('click', () => box.close());
      previous.addEventListener('click', () => lightMove(-1));
      next.addEventListener('click', () => lightMove(1));

      previous.hidden = links.length < 2;
      next.hidden = links.length < 2;

      box.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          lightMove(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          lightMove(1);
        }
      });

      box.addEventListener('close', () => {
        large.removeAttribute('src');

        if (opener?.isConnected) {
          opener.focus({ preventScroll: true });
        }
      });
    }

    links.forEach((link, index) => {
      link.addEventListener('click', event => {
        if (
          event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          event.altKey ||
          typeof HTMLDialogElement === 'undefined'
        ) {
          return;
        }

        event.preventDefault();

        if (!box) createLightbox();

        selected = index;
        opener = link;

        loadImage();

        if (!box.open) box.showModal();
      });
    });

    if (!root.classList.contains('pd-gallery--carousel')) return;

    /* CAROUSEL KONTROLLERİ */
    const controls = document.createElement('div');
    controls.className = 'pd-gallery__controls';

    controls.innerHTML = `
      <button
        type="button"
        class="pd-gallery__arrow"
        aria-label="Önceki görsel"
      >←</button>

      <div
        class="pd-gallery__dots"
        role="group"
        aria-label="Galeri sayfaları"
      ></div>

      <button
        type="button"
        class="pd-gallery__arrow"
        aria-label="Sonraki görsel"
      >→</button>
    `;

    track.after(controls);

    const previous = controls.firstElementChild;
    const next = controls.lastElementChild;
    const dots = controls.querySelector('.pd-gallery__dots');

    let positions = [0];
    let page = 0;
    let scrollFrame = 0;
    let measureFrame = 0;

    /* Aktif görsel ve buton durumları */
    function sync() {
      const left = track.scrollLeft;

      page = positions.reduce((best, value, index) => {
        return Math.abs(value - left) <
          Math.abs(positions[best] - left)
          ? index
          : best;
      }, 0);

      [...dots.children].forEach((dot, index) => {
        dot.setAttribute('aria-current', String(index === page));
      });

      previous.disabled = page === 0;
      next.disabled = page === positions.length - 1;
    }

    /* İstenen görsele git */
    function go(index) {
      const target = Math.max(
        0,
        Math.min(index, positions.length - 1)
      );

      track.scrollTo({
        left: positions[target] || 0,
        behavior: reduced() ? 'auto' : 'smooth'
      });
    }

    /* Görsel konumlarını hesapla */
    function measure() {
      if (!root.isConnected) return;

      const max = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      const origin = links[0].getBoundingClientRect().left;
      const measured = [];

      links.forEach(link => {
        const offset = Math.max(
          0,
          Math.min(
            max,
            link.getBoundingClientRect().left - origin
          )
        );

        if (
          !measured.length ||
          Math.abs(offset - measured[measured.length - 1]) > 1
        ) {
          measured.push(offset);
        }
      });

      positions = measured.length ? measured : [0];

      /* Noktaları yalnızca sayıları değiştiğinde oluştur */
      if (dots.children.length !== positions.length) {
        const fragment = document.createDocumentFragment();

        positions.forEach((_, index) => {
          const dot = document.createElement('button');

          dot.type = 'button';
          dot.className = 'pd-gallery__dot';
          dot.setAttribute(
            'aria-label',
            `${index + 1}. görsele git`
          );

          dot.addEventListener('click', () => go(index));

          fragment.append(dot);
        });

        dots.replaceChildren(fragment);
      }

      /* Birden fazla görsel varsa kontroller görünür kalsın */
      controls.hidden = links.length < 2;

      sync();
    }

    function scheduleMeasure() {
      cancelAnimationFrame(measureFrame);
      measureFrame = requestAnimationFrame(measure);
    }

    previous.addEventListener('click', () => go(page - 1));
    next.addEventListener('click', () => go(page + 1));

    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(sync);
      },
      { passive: true }
    );

    root.pdMeasure = scheduleMeasure;

    /* Mobil ekran ve galeri genişliği değişimleri */
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleMeasure);

      observer.observe(track);

      links.forEach(link => observer.observe(link));

      root.pdResizeObserver = observer;
    }

    /* Lazy-load görseller yüklendiğinde tekrar ölç */
    links.forEach(link => {
      const img = link.querySelector('img');

      if (img && !img.complete) {
        img.addEventListener('load', scheduleMeasure, {
          once: true
        });
      }
    });

    scheduleMeasure();
  }

  function scan() {
    document.querySelectorAll('.pd-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, {
      once: true
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);

  document.addEventListener('shopify:section:unload', event => {
    const roots = [];

    if (event.target.matches?.('.pd-gallery')) {
      roots.push(event.target);
    }

    event.target.querySelectorAll?.('.pd-gallery').forEach(root => {
      roots.push(root);
    });

    roots.forEach(root => {
      root.pdResizeObserver?.disconnect();
    });
  });

  window.addEventListener(
    'resize',
    () => {
      document.querySelectorAll('.pd-gallery').forEach(root => {
        root.pdMeasure?.();
      });
    },
    { passive: true }
  );

  window.addEventListener('load', () => {
    document.querySelectorAll('.pd-gallery').forEach(root => {
      root.pdMeasure?.();
    });
  });
})();